<template>
  <div>
    <div>
      <h2>Client View</h2>
      <br/>
    </div>
    <div class="row">
      <div class="form-group col-md-4 row pull-left">
        <label class="padding-bottom-10">Filter by User</label>
        <input type="text" v-model="search" class="form-control">
        <button type="button" class="btn btn-primary margin-top-10 margin-left-0 margin-bottom-20" @click="searchAllInvestors">Filter</button>
      </div>
    </div>
    <div v-if="spinner" class="text-center">
      <img src="../../../images/loader.gif" height="25px" width="25px"/>
      <p>Please wait ... </p>
    </div>
  <table class="table" v-if="dataReady">
    <thead>
    <tr>
      <th
          v-for="(column,label) in columns"
          @click="sort(label)"
      >
        {{ column.label }}
      </th>
      <th>
        <button type="button" class="btn btn-xs btn-default" @click="selectAll">
          {{ allSelected ? 'Deselect All' : 'Select All' }}
        </button>
      </th>
      <th>
        <button type="button" class="btn btn-xs btn-primary" @click="sendBulkInvite" :disabled="selectedInvestors.length === 0">
          Send Invite
        </button>
        <br>
        Last Invite
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="investor in filteredInvestors" :key="investor.investor.id">
      <td>{{ investor.investor.email }}</td>
      <td>{{ investor.investor.full_name }}</td>
      <td>
        <input type="checkbox" 
               :value="investor.investor.id" 
               v-model="selectedInvestors"
               @change="updateSelectAll">
      </td>
      <td>{{ formatDate(investor.last_invite_sent_at) }}</td>
    </tr>
    </tbody>
  </table>
      <invite-investor-modal :offering-list="offeringList" :doc-flows="docFlowList" :show-invite="showInviteModal" :profile-data="profileData" @cancel="cancel" @ok="ok"></invite-investor-modal>
    <div>
      <pagination :limit="10" :data="investors" @pagination-change-page="getNewInvestors"></pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InviteInvestorModal from "./InviteInvestorModal";
import pagination from "laravel-vue-pagination"

function by(getValue, dir) {
  return (a, b) => {
    let result = getValue(a) > getValue(b) ? 1 : -1
    return result * dir;
  }
}

export default {
  name: "ClientView",
  components: {
    InviteInvestorModal,
    pagination

  },
  props: {
    'filter':'',
    'activeEmd': Object,
    'isAdmin': Boolean,
    'offeringList': Array,
    'docFlowList': Array,
  },
  computed: {
    filteredInvestors() {
      const sort = this.columns[this.sortBy].sort;
      const sorted = this.investors.data.sort(by(sort, this.sortDir));

      return sorted
    },
    setRepLabel() {
      return this.activeEmd.is_non_brokered ? 'Rep' : 'Dealing Rep'
    },
    allSelected() {
      return this.selectedInvestors.length === this.investors.data?.length && this.investors.data?.length > 0
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedInvestors = [];
      } else {
        this.selectedInvestors = this.investors.data.map(investor => investor.investor.id);
      }
    },
    updateSelectAll() {
    },
    sendBulkInvite() {
      if (this.selectedInvestors.length === 0) {
        alert('Please select at least one investor to invite.');
        return;
      }
      
      const firstSelectedInvestor = this.investors.data.find(inv => inv.investor.id === this.selectedInvestors[0]);
      
      if (firstSelectedInvestor) {
        this.profileData.id = firstSelectedInvestor.investor.id;
        this.profileData.first_name = firstSelectedInvestor.investor.first_name;
        this.profileData.last_name = firstSelectedInvestor.investor.last_name;
        this.profileData.full_name = firstSelectedInvestor.investor.full_name;
        this.profileData.email = firstSelectedInvestor.investor.email;
        this.profileData.selectedInvestors = this.selectedInvestors;
        
        this.showInvite();
      }
    },
    searchAllInvestors() {
      if((this.search || this.drSearch) !== '') {
        this.getNewInvestors()
      }
    },
    getNewInvestors(page = 1) {
      this.spinner = true
      this.dataReady = false
      let getInvestors = 'investor/newInvestors?page=' + page + '&filterByName=' + this.search + '&filterByRepName=' + this.drSearch
      return axios.get(getInvestors).
          then( response => {
            this.investors = response.data
            this.dataReady = true
            this.spinner = false
            return Promise.resolve()
      }).catch(errors =>{
        this.spinner = false
        return Promise.reject()
      })
    },
    viewInvestments(investor) {
      this.saveFilter(this.statusFilter)
      window.location.href = 'console?filterByName=' + investor.investor.full_name
    },
    getInvestorInvite(investor) {
      this.profileData.id = investor.investor.id
      this.profileData.first_name = investor.investor.first_name
      this.profileData.last_name = investor.investor.last_name
      this.profileData.full_name = investor.investor.full_name
      this.profileData.email = investor.investor.email
      this.profileData.selectedInvestors = [investor.investor.id]

      this.showInvite()
    },
    dealingRepFormatter(dealingRep) {
      if (!dealingRep) {
        return ""
      } else {
        return dealingRep.full_name
      }
    },
    sort(column) {
      if (this.sortBy === column) {
        this.sortDir *= -1;
      }

      this.sortBy = column;
    },
    saveFilter(status) {
      let statusObj = {filter: status};
      window.history.pushState(
          statusObj,
          status,
          `/admin/${this.activeEmd.slug}/investor?filter=${status}`
      )
    },
    showInvite() {
      this.showInviteModal = true;
    },
    cancel() {
      this.showInviteModal = false
      this.selectedInvestors = [];
    },
    ok() {
      this.showInviteModal = false
      this.selectedInvestors = [];
    },
  },
    data() {
      return {
        statusFilter: this.filter,
        sortBy: 'email',
        sortDir: 1,
        search: '',
        drSearch: '',
        investors: {},
        spinner: false,
        showInviteModal: false,
        dataReady: false,
        selectedInvestors: [],
        profileData: {
          id: 0,
          first_name: '',
          last_name: '',
          full_name: '',
          email: '',
          selectedInvestors: []
        },
        columns: {
          email: {
            label: 'User Email',
            sort: i => i.investor.email
          },
          user_name: {
            label: 'User Name',
            sort: i => i.investor.full_name
          },
        }
      }
    },
  created() {
    this.getNewInvestors()
  }
}
</script>